import { ITextFieldProps, TextField, Text } from "@fluentui/react";
import React, { useImperativeHandle, useState } from "react";

export interface RefTextFieldRef {
  getValue: () => string;
  reset: () => void;
  setInitialValue: (theValue: string) => void;
}

export interface RefTextFieldProps {
  customRef: React.Ref<RefTextFieldRef>;
  label: string;
  styles?: ITextFieldProps["styles"];
  required?: boolean;
  type?: string;
  autoComplete?: string;
}

const RefTextField: React.FC<RefTextFieldProps> = (props) => {
  const [value, setValue] = useState<string>("");

  useImperativeHandle(props.customRef, () => ({
    getValue: () => {
      return value;
    },
    reset: () => {
      setValue("");
    },
    setInitialValue: (theValue: string) => {
      setValue(theValue);
    }
  }));
  return (
    <>
      <TextField
        value={value}
        label={props.label}
        placeholder={props.label === "Doc Number/s:" ? "Multiples allowed seperated by comma (,)" : ""}
        errorMessage={
          props.label === "Doc Number/s:" && props.type != "number" && value && !/^(\d+)(,\d+)*$/.test(value)
            ? "Please enter Numbers separated by commas"
            : ""
        }
        onChange={(_, value) => {
          setValue(value || "");
        }}
        styles={props.styles}
        required={props.required}
        autoComplete={props.autoComplete || "off"}
      />
      {props.label === "Doc Number/s:" && props.type !== "number" && (
        <Text
          nowrap
          variant="xSmall"
          block
          style={{
            marginTop: "4px",
            color: "var(--accent-font-color, black)"
          }}
        >
          Enter only numbers separated by commas
        </Text>
      )}
    </>
  );
};

RefTextField.displayName = "RefTextField";
export { RefTextField };
